var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRotateImage = function SvgRotateImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 21",
    style: {
      enableBackground: "new 0 0 20 21"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3 1.5c.7.7.7 1.8 0 2.4l-.8.6c3.7.6 6.5 3.7 6.5 7.5v.5c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5V12c0-2-1.3-3.7-3.2-4.3l.4.4c.7.7.7 1.8 0 2.4-.7.7-1.8.7-2.4 0L7 6l4.8-4.5c.7-.7 1.8-.7 2.5 0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 13c0-1.7 1.3-3 3-3h5c1.7 0 3 1.3 3 3v5c0 1.7-1.3 3-3 3H3c-1.7 0-3-1.3-3-3v-5zm3-.2h5c.1 0 .2.1.2.2v5c0 .1-.1.2-.2.2H3c-.1 0-.2-.1-.2-.2v-5c0-.1.1-.2.2-.2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgRotateImage;